import InputLabelWrapper from "components/basic/input-label-wrapper/InputLabelWrapper";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import React from "react";
import { T } from "services/lang/LanguageService";
import { DatasetScatterProps, ImageConfig } from "../interfaces";

interface DatasetScatterChartImageEditorProps {
  config: DatasetScatterProps;
  onConfigChange: (config: DatasetScatterProps) => void;
}

const DatasetScatterChartImageEditor = ({ config, onConfigChange }: DatasetScatterChartImageEditorProps) => {
  const handleImageConfigChange = (field: keyof ImageConfig, value: string | number | null) => {
    if ((value === null || value === "") && config.imageConfig) {
      const { [field]: remove, ...rest } = config.imageConfig;
      onConfigChange({ ...config, imageConfig: { ...(rest as ImageConfig) } });
      return;
    }
    onConfigChange({ ...config, imageConfig: { ...config?.imageConfig!, [field]: value } });
  };

  return (
    <div className="grid p-fluid">
      <InputLabelWrapper labelName={T("label.scatter.image-source")}>
        <InputText
          value={config?.imageConfig?.source ?? ""}
          onChange={e => handleImageConfigChange("source", e.target.value)}
        />
      </InputLabelWrapper>
      <InputLabelWrapper labelName="X" col={1}>
        <InputNumber value={config?.imageConfig?.x} onChange={e => handleImageConfigChange("x", e.value)} />
      </InputLabelWrapper>
      <InputLabelWrapper labelName="Y" col={1}>
        <InputNumber value={config?.imageConfig?.y} onChange={e => handleImageConfigChange("y", e.value)} />
      </InputLabelWrapper>
      <InputLabelWrapper labelName={`X ${T("word.size")}`} col={1}>
        <InputNumber
          value={config?.imageConfig?.sizex}
          onChange={e => handleImageConfigChange("sizex", e.value)}
        />
      </InputLabelWrapper>
      <InputLabelWrapper labelName={`Y ${T("word.size")}`} col={1}>
        <InputNumber
          value={config?.imageConfig?.sizey}
          onChange={e => handleImageConfigChange("sizey", e.value)}
        />
      </InputLabelWrapper>
      <InputLabelWrapper labelName={T("word.opacity")} col={1}>
        <InputNumber
          value={config?.imageConfig?.opacity}
          onChange={e => handleImageConfigChange("opacity", e.value)}
          maxFractionDigits={2}
        />
      </InputLabelWrapper>
    </div>
  );
};

export default DatasetScatterChartImageEditor;
